import { AccesoController } from "../../acceso/AccesoController.js";
import { VacacionesController } from "../../vacaciones/VacacionesController.js";
import { SesionService } from "../services/SesionService.js";

// Router por hash (#seccion?query=x): funciona en cualquier hosting estatico sin rewrites.
//
// Para agregar una nueva seccion:
// 1. Crear src/<seccion>/<Seccion>Controller.js con un metodo render(params)
// 2. Importarlo aqui
// 3. Agregar la ruta en `routes` (envuelta en requireSesion si necesita empleado logueado)
export class Router {
  constructor() {
    this.routes = {
      "": () => this.inicio(),
      acceso: (params) => AccesoController.render(params),
      vacaciones: (params) => this.requireSesion(() => VacacionesController.renderListado(params)),
      "vacaciones/editar": (params) => this.requireSesion(() => VacacionesController.renderEditar(params)),
    };
  }

  init() {
    window.addEventListener("hashchange", () => this.handleRoute());
    this.handleRoute();
  }

  handleRoute() {
    const hash = window.location.hash.slice(1) || "";
    const [path, queryString] = hash.split("?");
    const route = this.routes[path] || this.routes[""];
    const params = queryString ? new URLSearchParams(queryString) : new URLSearchParams();
    window.scrollTo(0, 0);
    route(params);
  }

  // Sin hash: al listado si hay sesion, si no al acceso.
  inicio() {
    this.navigate(SesionService.empleado() ? "vacaciones" : "acceso");
  }

  requireSesion(callback) {
    if (SesionService.empleado()) return callback();
    this.navigate("acceso");
  }

  navigate(path) {
    if (window.location.hash.slice(1) === path) return this.handleRoute();
    window.location.hash = path;
  }
}
